import {
  SET_PERSONAL_INFO,
  SET_PERSONAL_SINGLES,
  SET_PERSONAL_ALBUMS
} from "@/store/mutation-types";

export default {
  [SET_PERSONAL_INFO](state, info = {}) {
    state.info = { ...state.info, ...info };
  },
  [SET_PERSONAL_SINGLES](state, singles = []) {
    state.singles = [...singles];
  },
  [SET_PERSONAL_ALBUMS](state, albums = []) {
    state.albums = [...albums];
  }
};
